import api from "@/api.js";

export default {
  state: {
    dirtyCheckFields: {
      "basic": ["name"],
      "venue": ["venue.xyz"]
    },
    bases: [],
    basesLoading: false
  },
  mutations: {
    setBases(state, payload) {
      state.bases = payload;
    },
    setBasesLoading(state, payload) {
      state.basesLoading = payload;
    }
  },
  actions: {
    async loadBases({ commit, state }) {
      let bases;

      bases = await api.get("bases");

      commit("setBases", bases.data);
    },

    async saveBase({ commit }, payload) {
      await api.put("bases", payload);
    },

    async deleteBase({ commit }, payload) {
      await api.delete("bases/" + payload.id);
    },

    async saveBaseImage({ commit }, payload) {
      // console.log(payload)
      await api.post("baseImage", payload);
    }
  },
  getters: {
    bases(state) {
      return state.bases;
    },
    basesLoading(state) {
      return state.basesLoading;
    }
  }
};
